import { OnboardingTooltip } from '@cian/ui-kit';
import * as React from 'react';

import { CompareOnboardingContent } from './CompareOnboardingContent';
import * as styles from './NewbuildingHeaderCompareButton.css';

interface ICompareButtonOnboardingProps extends React.PropsWithChildren {
  open: boolean;
  onClose(): void;
}

export function CompareButtonOnboarding({ children, open, onClose }: ICompareButtonOnboardingProps) {
  return (
    <OnboardingTooltip
      theme="black"
      content={<CompareOnboardingContent />}
      placement="bottom"
      portal={false}
      open={open}
      onClose={onClose}
      flip={false}
    >
      <div className={styles['onboarding-anchor']}>{children}</div>
    </OnboardingTooltip>
  );
}
